import React, { useEffect, useState } from "react";
import AcreDappContext from "../context";
import { useConnectWallet, useWallets } from "@web3-onboard/react";
//import {contract} from '../../contracts/TestContract.js';

function AcreDappProvider({ children }) {
  const [walletAddress, setWalletAddress] = useState();
  const [walletContext, setWalletContext] = useState();
  const [currentWalletState, setCurrentWalletState] = useState();
  const [contractABI, setContractABI] = useState(/* contract.abi */); //Smart Contract ABI here
  const [marketAddress, setMarketAddress] = useState(""); //Smart Contract Address Here
  const [{ wallet }] = useConnectWallet();
  const connectedWallets = useWallets();


  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (wallet && connectedWallets) {
    setWalletAddress(wallet.accounts[0].address);
    setWalletContext(wallet);
    setCurrentWalletState(connectedWallets); 
    }
    
  }, [wallet, connectedWallets]);

  return (
    <AcreDappContext.Provider
      value={{
        walletAddress,
        setWalletAddress,
        walletContext,
        setWalletContext,
        currentWalletState,
        setCurrentWalletState,
        marketAddress,
        setMarketAddress,
        contractABI,
        setContractABI
      }}
    >
      {children}
    </AcreDappContext.Provider>
  );
}

function useAcreDapp() {
  const context = React.useContext(AcreDappContext);
  if (context === undefined) {
    throw new Error("useAcreDapp must be used within a AcreDappProvider");
  }
  return context;
}

export { AcreDappProvider, useAcreDapp };
